import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(_Circle, { cx: "12", cy: "11", r: "1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M11 17a1 1 0 0 1 2 0c0 .5-.34 3-.5 4.5a.5.5 0 0 1-1 0c-.16-1.5-.5-4-.5-4.5Z",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "M8 14a5 5 0 1 1 8 0", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M17 18.5a9 9 0 1 0-10 0", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Podcast";
const Podcast = memo(themed(Icon));
export {
  Podcast
};
//# sourceMappingURL=podcast.js.map
